import './Category.css';

function Category(props) {
    if(props.data.Children.length > 0)
        return (
            <details className='category' open={props.data.expanded}>
                <summary>
                    <input type="checkbox" name={props.data.ID} checked={props.data.selected} onChange={() => props.onSelect(props.data.ID)}/>
                    <label className='labelAlign' htmlFor={props.data.ID}>{props.data.Nome}</label>
                </summary>
                {props.data.Children.map((c) => <Category key={c.ID} data={c} onSelect={props.onSelect}/>)}
            </details>
        )
    else
        return (
            <p className='category'>
                <input type="checkbox" name={props.data.ID} checked={props.data.selected} onChange={() => props.onSelect(props.data.ID)}/>
                <label className='labelAlign' htmlFor={props.data.ID}>{props.data.Nome}</label>
            </p>
        )
            
}

export default Category;